import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TenantUsageMeter, TenantUsageMeterCreate, TenantUsageMeterFilter } from '../data/tenantUsageMeter';

export function createTenantUsageMeterService(client: AxiosInstance) {
  return createCrudService<TenantUsageMeter, TenantUsageMeterCreate, TenantUsageMeterFilter>(
    client,
    '/tenancy/TenantUsageMeter',
    'id',
  );
}

export type TenantUsageMeterService = CrudService<TenantUsageMeter, TenantUsageMeterCreate, TenantUsageMeterFilter>;
